jQuery(($) => {
    let activeTab = null;

    function setActiveTab(tabId) {
        // Hide the current active tab content
        if (activeTab) {
            $(`.tabcontent[data-tab-id="${activeTab}"]`).hide();
            $(`.tab-button[data-tab-id="${activeTab}"]`).removeClass('active');
        }

        // Show the new active tab content
        activeTab = tabId;
        $(`.tabcontent[data-tab-id="${tabId}"]`).show();
        $(`.tab-button[data-tab-id="${tabId}"]`).addClass('active');
    }

    // Set the default active tab
    const defaultTab = $('.tab-button').first();
    if (defaultTab.length) {
        setActiveTab(defaultTab.data('tab-id'));
    }

    // Set up click event for tabs
    $('.tab-button').on('click', function (e) {
        e.preventDefault();
        const tabId = $(this).data('tab-id');
        setActiveTab(tabId);
    });
});
